import React, {FC, useState} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {OkCancelDialog} from '../../../common/dialogs/okCancelDialog';
import {SideFrameDialogMessage} from './sideFrameDialogMessage';
import {SideFrameDialogDefinition} from './sideFrameDialogsHooks';

/*
 * Props.
 */

interface SideFramePromptProps {
  promptData: PromptDefinition;
  onValue: HandlerOf<string | null>;
}

/*
 * Component.
 */

const SideFramePrompt: FC<SideFramePromptProps> = ({promptData, onValue}) => {
  const {title, message, okTitle, cancelTitle, val} = promptData;
  const [promptValue, setPromptValue] = useState(val || '');

  return (
    <OkCancelDialog
      title={title}
      okButtonLabel={okTitle}
      cancelButtonLabel={cancelTitle}
      onOkClick={() => onValue(promptValue)}
      onRequestClose={() => onValue(null)}
    >
      <SideFrameDialogMessage>{message}</SideFrameDialogMessage>
      <TextBox size={VisualSizesEnum.LARGE} value={promptValue} onChange={setPromptValue} shouldAutoFocus />
    </OkCancelDialog>
  );
};

/*
 * Hook.
 */

interface PromptDefinition extends SideFrameDialogDefinition {
  title: string;
  message: string;
  okTitle: string | null;
  cancelTitle: string | null;
  val: string | null;
}

export function useSideFramePrompt() {
  const [promptData, setPromptData] = useState<PromptDefinition | null>(null);
  if (!promptData) {
    return {
      setPromptData,
      prompt: null,
    };
  }

  const onValue = (promptValue: string | null) => {
    if (!promptData) {
      return;
    }

    promptData.onDone(promptValue);
    setPromptData(null);
  };

  return {
    setPromptData,
    prompt: <SideFramePrompt promptData={promptData} onValue={onValue} />,
  };
}
